import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-assign-licenses-support-article',
    template: `
        <ng-container i18n="@@support.articles.assignLicenses">
            <p>When you purchase licenses in advance, you can easily assign them to students.</p>
            <p>
                <a routerLink="/support/organizations/licenses/advance-order" mat-stroked-button color="primary" class="supportLink">Order in advance</a>
            </p>

            <h2>Activate while enrolling students</h2>
            <p>When you enroll students, we check if you have enough licenses available to activate each student. When there are enough licenses available, you can activate them immediately with one push of the <strong>Activate licenses</strong> button.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/sufficientLicenses.png" />
            </figure>
            <p>If you have fewer licenses available than necessary, the order form will appear. If you want to use your available licenses for some of these students? Then close the order form and activate the students individually (see below).</p>

            <h2>Activate individually</h2>
            <ol>
                <li>
                    <div>
                        On your <a routerLink="/organization/dashboard">Dashboard</a> or in the <a routerLink="/organization/licenses">License overview</a> you can see how many of your students are <strong>unlicensed </strong> or have an <strong>expired license</strong>.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/licensesOverview.png" />
                    </div>
                </li>
                <li>
                    <span>Click <strong>View list</strong> to view these students.</span>
                </li>
                <li>
                    <span>
                        At the right side of each student, click the <strong>Activate license</strong> button.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentsWithoutLicense.png" />
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class AssignLicensesSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
